/*jshint esversion: 6*/

import Intro from './components/page/Intro';
import Home from './components/page/Home';
import Why from './components/page/Why';
import Basic from './components/page/basic';
import Tools from './components/page/Tools';
import People from "@/components/page/People";
import Feedback from "@/components/page/Feedback";

const routes = [
    { 
        path: '*/',
        name: 'Intro',
        component: Intro
    },{ 
        path: '/home',
        name: 'HomePage', 
        component: Home 
    },{ 
        path: '/why',
        name: 'WhyHome',
        component: Why 
    },
    /// HOW ROUTES ///
    { 
        path: '/tools',
        name: 'ToolsHome',
        component: Tools
    },
    {
        path: '/people',
        name: 'People',
        component: People
    },
    {
        path: '/feedback',
        name: 'Feedback',
        component: Feedback
    },

    /// WHAT 'STANDARD' ROUTES ///

    /// WHAT 'BASICS' ROUTES
    { 
        path: '/what', 
        name: 'BasicHome',
        component: Basic 
    }

];

export default routes;